import "./styles/Reports.css"
import ReportsTable from "../../../ui/table/ReportsTable"
import reportsColumns from "./columns/reportsColumns"
import React, { FC, useEffect, useState } from "react"
import { RootState } from "../../../../store"
import { connect } from "react-redux"
import { ReportsProps, SelectOption, User } from "../../../../types"
import { fetchReportsData } from "../../../../actions/reportsActions"
import { lang } from "../../../../constants/languages"

const Reports: FC<ReportsProps> = (props) => {
  const { fetchReportsData } = props

  const [loading, setLoading] = useState(true)

  const [approveDisabled, setApproveDisabled] = useState<boolean>(false)

  const limit = 10

  useEffect(() => {
    if (!props.isAdmin) {
      fetchReportsData(undefined, undefined, props.selectedAccount?.value2).then(() => setLoading(false))
    } else if (props.isAdmin && props.selectedUser?.value) {
      fetchReportsData(props.selectedUser?.value, approveDisabled, props.selectedAccount?.value2).then(() =>
        setLoading(false)
      )
    }
  }, [props.selectedUser, approveDisabled, props.selectedAccount])

  const onClickPage = () => {
    setLoading(true)
    fetchReportsData(props.selectedUser?.value, undefined, props.selectedAccount?.value2).then(() => setLoading(false))
  }

  return (
    <div className="catalog flex bg-[#fff]" style={{ flexDirection: "column" }}>
      <div className={`grow flex justify-center`}>
        <div className={"w-full"}>
          <ReportsTable
            title={lang.reports.title}
            pagination
            minRowCount={limit}
            limit={limit}
            columns={reportsColumns}
            data={props.paymentHistory}
            count={props.paymentHistory.length}
            onClickPage={onClickPage}
            rowHeightInPx={40}
            loading={loading}
            isAdmin={props.isAdmin}
            selectedUserId={props.selectedUser?.value}
            approveDisabled={approveDisabled}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user,
    paymentHistory: state.reportsData.paymentHistory
  }
}

export default connect(mapStateToProps, { fetchReportsData })(Reports)
